import { green, lime, orange, red, teal } from '@material-ui/core/colors';

const accent = {
    greenDark: green[900],
    greenLight: green[200],
    greenMain: green[500],
    limeDark: lime[900],
    limeLight: lime[200],
    limeMain: lime[500],
    orangeDark: orange[900],
    orangeLight: orange[200],
    orangeMain: orange[500],
    redDark: red[900],
    redLight: red[200],
    redMain: red[500],
    tealDark: teal[900],
    tealLight: teal[200],
    tealMain: teal[500],
};
export default accent;
